import { useState, useEffect } from 'react';
import { getMediaList, getMediaFileUrl } from '../api/media';

// Wiederverwendbarer Bibliotheks-Picker: Modal mit Bild-Grid der Mandanten-Medien.
// onPick(media) wird mit der gewählten Media-Zeile aufgerufen; kein neuer Upload.
export default function MediaLibraryPicker({ show, onPick, onClose }) {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!show) return;
    setSearch('');
    setLoading(true);
    setError('');
    getMediaList('image')
      .then((list) => setMedia(list || []))
      .catch((e) => setError(e.message || 'Fehler beim Laden der Bibliothek.'))
      .finally(() => setLoading(false));
  }, [show]);

  if (!show) return null;

  const q = search.trim().toLowerCase();
  const filtered = q
    ? media.filter((m) => (m.file_name || '').toLowerCase().includes(q)
        || (m.meta_info?.exercise_name || '').toLowerCase().includes(q))
    : media;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-images me-2" />
                Aus Bibliothek wählen
              </h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              {error && (
                <div className="alert alert-danger py-2">
                  <i className="bi bi-exclamation-triangle me-1" />
                  {error}
                </div>
              )}
              {loading ? (
                <div className="text-center py-4 text-muted">
                  <span className="spinner-border spinner-border-sm me-2" />
                  Lade Bibliothek…
                </div>
              ) : media.length === 0 ? (
                <div className="text-center py-4 text-muted">
                  <i className="bi bi-inbox d-block fs-1 mb-2" />
                  Noch keine Bilder in der Bibliothek. Lade zuerst welche unter „Medien" hoch.
                </div>
              ) : (
                <>
                  <div className="input-group input-group-sm mb-3">
                    <span className="input-group-text"><i className="bi bi-search" /></span>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Suchen (z. B. Liegestütz)…"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      autoFocus
                    />
                  </div>
                  {filtered.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                      <i className="bi bi-search d-block fs-3 mb-2" />
                      Keine Treffer für „{search.trim()}".
                    </div>
                  ) : (
                    <div className="row g-2">
                      {filtered.map((m) => (
                        <div key={m.id} className="col-4 col-md-3">
                          <button
                            type="button"
                            className="btn p-0 border rounded w-100 h-100 overflow-hidden"
                            title={m.file_name}
                            onClick={() => onPick(m)}
                            style={{ aspectRatio: '1 / 1' }}
                          >
                            <img
                              src={getMediaFileUrl(m.id)}
                              alt={m.file_name}
                              className="w-100 h-100"
                              style={{ objectFit: 'cover' }}
                            />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show" onClick={onClose} />
    </>
  );
}
